import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantMemberMenuRegistry = {
    core_tenantMember: {
        label: "Tenant Member",
        link: PAGE_URL.TENANT_MEMBER_PAGE,
        key: PAGE_URL.TENANT_MEMBER_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantMemberMenuRegistry;
